'use strict';
angular.module('resCenDigitalPreviewModule', [
    'resCenDigitalPreviewDetailModule',
    'resCenDigitalPreviewOtherDetailModule', 'digitalQuickPreviewModule',
])
    .controller('resCenDigitalPreviewCtrl', [
        function() {

        },
    ]);
